import React from 'react';
import { motion } from "motion/react";
import { EventScheduleCardSkeleton } from './EventScheduleCardSkeleton';
import { TicketCardSkeleton } from './TicketSkeleton';

interface TicketSkeletonsProps {
  type?: 'tickets' | 'events';
  count?: number;
}

// const SkeletonPulse: React.FC<{ className?: string; delay?: number }> = ({ 
//   className = "", 
//   delay = 0 
// }) => (
//   <motion.div
//     className={`bg-gray-700 rounded ${className}`}
//     animate={{
//       opacity: [0.4, 0.8, 0.4],
//     }}
//     transition={{
//       duration: 1.5,
//       repeat: Infinity,
//       delay,
//       ease: "easeInOut"
//     }}
//   />
// );

export const TicketSkeletons: React.FC<TicketSkeletonsProps> = ({ 
  type = 'events', 
  count = 3 
}) => {
  if (type === 'events') {
    return <EventScheduleCardSkeleton count={count} />;
  }

  return (
    <motion.div 
      className="space-y-3 sm:space-y-4 lg:space-y-6 pb-2 sm:pb-3 lg:pb-4"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ delay: 0.2, duration: 0.4 }}
    >
      {Array.from({ length: count }).map((_, index) => (
        <motion.div
          key={index}
          initial={{ opacity: 0, y: 30, scale: 0.95 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          transition={{ 
            delay: 0.3 + index * 0.1, 
            type: "spring", 
            stiffness: 300, 
            damping: 30,
            mass: 0.8
          }}
        >
          <TicketCardSkeleton />
        </motion.div>
      ))}
    </motion.div>
  );
};

// Individual skeleton components for specific use cases
export const TicketCardSkeletons: React.FC<{ count?: number }> = ({ count = 3 }) => (
  <TicketSkeletons type="tickets" count={count} />
);

export const EventSkeletons: React.FC<{ count?: number }> = ({ count = 3 }) => (
  <motion.div
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    exit={{ opacity: 0 }}
    transition={{ duration: 0.2 }}
  >
    <TicketSkeletons type="events" count={count} />
  </motion.div>
);
